export default __webpack_public_path__ + "static/5_9-4c005eff132cc3a5685622c6f78dbb24.png";